import { ContentComponent } from "components/flexComponents/Content/factory/ContentComponent";
import { ContentFlexComponent, ContentProps } from "components/flexComponents/Content/typings";

export class NullContentComponent extends ContentComponent {
  constructor(contentFlexComponent: ContentFlexComponent) {
    super(contentFlexComponent);
  }

  public shouldRender = (): boolean => false;

  /* istanbul ignore next */
  public generate(props: ContentProps) {
    return null;
  }
  public getId: () => string;
}
